import { gql } from "@apollo/client";
import {
  SerialNumberNoNestingFragment,
  PaginatedListMetaNoNestingFragment,
} from "@towersystems/roam-common/lib/generated-graphql-fragment";
import { SerialNumber as SerialNumberEntity } from "@towersystems/roam-common/lib/generated-types";
import { client } from "../../../apollo";
import SerialNumberModel from "../../data/model/SerialNumber";
import { listOptions, listVariables } from "../constants";
import { EntityResourceDefinition } from "../entity-resource-definition";
import { pageQuery } from "../page-query";

const serialNumbersQuery = gql`
 ${SerialNumberNoNestingFragment}
 ${PaginatedListMetaNoNestingFragment}
query GetSerialNumbers(${listVariables}) {
    serialNumbers(${listOptions}) {
        items {
          ...SerialNumberNoNesting
        }
        meta {
          ...PaginatedListMetaNoNesting
        }
    }
}
`;

export const serialNumberDefinition = new EntityResourceDefinition<
  SerialNumberEntity,
  SerialNumberModel
>({
  entity: "serial_numbers",
  query: serialNumbersQuery,
  prepareEntity: (newEntity, fetchedEntity) => {
    newEntity.value = fetchedEntity.value;
    newEntity.productLocationInventoryPricingId =
      fetchedEntity.productLocationInventoryPricingId;
  },
  fetchEntities: (options) => {
    return pageQuery(client, "serialNumbers", serialNumbersQuery, options);
  },
});
